import { render } from "./chair.vue?vue&type=template&id=74da7661&scoped=true"
import script from "./chair.vue?vue&type=script&lang=js"
export * from "./chair.vue?vue&type=script&lang=js"

import "./chair.vue?vue&type=style&index=0&id=74da7661&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74da7661"]])

export default __exports__